document.addEventListener('DOMContentLoaded', function () {
	const hideImageElement =
		document.getElementsByClassName('post-thumbnail')[0];
	if (hideImageElement && window.hmUtils && !window.hmUtils.isMobile()) {
		hideImageElement.style.display = 'block';
	} else {
		hideImageElement.remove();
	}
});
